import { render, staticRenderFns } from "./tableReimbursApproval.vue?vue&type=template&id=134450f6&scoped=true"
import script from "./tableReimbursApproval.vue?vue&type=script&lang=js"
export * from "./tableReimbursApproval.vue?vue&type=script&lang=js"
import style0 from "./tableReimbursApproval.vue?vue&type=style&index=0&id=134450f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134450f6",
  null
  
)

export default component.exports